export const COUNTRIES = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Myanmar',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Cook Islands',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Timor-Leste',
  'Tokelau',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Faroe Islands',
  'Falkland Islands',
  'Finland',
  'France',
  'French Polynesia',
  'Gabon',
  'Gambia',
  'Georgia',
  'Gibraltar',
  'Germany',
  'Ghana',
  'Greece',
  'Greenland',
  'Guadeloupe',
  'Grenada',
  'Guernsey',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Jordan',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Jersey',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'North Korea',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Marshall Islands',
  'Macau',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Moldova',
  'Mongolia',
  'Montenegro',
  'Monaco',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Oman',
  'Pakistan',
  'Pitcairn',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'South Korea',
  'Lithuania',
  'Qatar',
  'Romania',
  'Rwanda',
  'Réunion',
  'Saint Lucia',
  'San Marino',
  'Saint Kitts and Nevis',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Saudi Arabia',
  'Senegal',
  'South Georgia and the South Sandwich Islands',
  'Sao Tome and Principe',
  'Sierra Leone',
  'Serbia',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tonga',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vatican City State (Holy See)',
  'Wallis and Futuna',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const BLACK_LIST_COUNTRIES = {
  'American Samoa': true,
  Anguilla: true,
  'Antigua and Barbuda': true,
  Bahamas: true,
  Belize: true,
  Fiji: true,
  Guam: true,
  Palau: true,
  Panama: true,
  Russia: true,
  Samoa: true,
  Seychelles: true,
  'Trinidad and Tobago': true,
  'Turks and Caicos Islands': true,
  'US Virgin Islands': true,
  Vanuatu: true,
};

export const COUNTRY_SELECT_OPTIONS = COUNTRIES.map((item) => ({
  label: item,
  value: item,
})).filter((item) => !(item.label in BLACK_LIST_COUNTRIES));
